export default function streamHasDTCPackage(stream = {}, packageName) {
    if (stream.packages && packageName) {
        return stream.packages.indexOf(packageName) > -1;
    }
    return false;
};



// WEBPACK FOOTER //
// ./app/lib/auth/streamHasDTCPackage.js